import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { MODULE_NAMESPACE_ALIAS } from '../../common/constants';
/**
 * Here we import what we need to make SystemJS work as a global.
 * This file is marked as containing a sideEffect in the package.json
 *
 *   "sideEffects": [
 *     "./src/services/remote-setup/index.ts"
 *   ],
 *
 * The import extension is needed for those environments (eg. Mocha)
 * that can't map the path to the file correctly.
 */ // eslint-disable-next-line import/extensions
require('systemjs/dist/system.js');

/**
 * This function loops through the external defined modules and adds them into the System registry
 * by requiring them at runtime from the product
 *
 * @param modulesToLoad
 */
export var setupSystemModules = function setupSystemModules(modulesToLoad) {
  if (modulesToLoad.length > 0) {
    var systemModulesToSet = modulesToLoad.map(function (module) {
      switch (module.name) {
        case 'react':
          return {
            module: module.name,
            import: require('react'),
            // require cannot be dynamic. It needs to be a known value at build time
            isDefault: true // it appears that modules with defaults NEED this, and it won't affect modules without defaults
          };

        case 'react-dom':
          return {
            module: module.name,
            import: require('react-dom'),
            isDefault: true
          };
        case 'react-intl-next':
          return {
            module: module.name,
            import: require('react-intl-next'),
            isDefault: true
          };
        case '@emotion/react':
          return {
            module: module.name,
            import: require('@emotion/react'),
            isDefault: false
          };
      }
      console.error("Excluded system module [".concat(module.name, "] must be setup inside '/remote-setup/index.ts'. Modules cannot be excluded and required dynamically."));
      return {
        module: module.name,
        import: undefined,
        isDefault: false
      };
    });

    // set them into the ImportMap scopes to ensure that they aren't available to other modules doing similar things
    var scopedModules = systemModulesToSet.reduce(function (acc, entry) {
      if (!entry.import) {
        return acc;
      }
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, entry.module, [MODULE_NAMESPACE_ALIAS, entry.module].join(':')));
    }, {});
    var _iterator = _createForOfIteratorHelper(systemModulesToSet),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        if (entry.import) {
          // add the entry into the SystemJS registry so that it can be shared using a module-map
          // entry.isDefault could be set to always true, it doesn't appear to impact modules without defaults, but have kept the alternate in case
          if (entry.isDefault) {
            System.set(scopedModules[entry.module], _objectSpread(_objectSpread({}, entry.import), {}, {
              default: entry.import,
              __useDefault: true
            }));
          } else {
            System.set(scopedModules[entry.module], entry.import);
          }
        } else {
          console.error("Unable to set import for module [".concat(entry.module, "]. Please ensure it has been installed and is available."));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return scopedModules;
  }
  return null;
};